/// <amd-module name="SuiteCommerce.Blog.Common.Instrumentation.Helper"/>
define("SuiteCommerce.Blog.Common.Instrumentation.Helper", ["require", "exports", "SuiteCommerce.Blog.Instrumentation"], function (require, exports, Instrumentation_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.ComponentArea = 'SC Blog';
    exports.ExtensionVersion = '2.1.1';
    exports.QueueNameSuffix = '-Blog';
    var InstrumentationHelper = /** @class */ (function () {
        function InstrumentationHelper() {
        }
        InstrumentationHelper.initializeInstrumentation = function (environment) {
            Instrumentation_1.default.initialize({
                environment: environment,
                queueNameSuffix: exports.QueueNameSuffix,
                defaultParameters: {
                    componentArea: exports.ComponentArea,
                    extensionVersion: exports.ExtensionVersion,
                },
            });
        };
        return InstrumentationHelper;
    }());
    exports.InstrumentationHelper = InstrumentationHelper;
});
